export type ArrowCommand = 'ArrowDown' | 'ArrowUp' | 'ArrowLeft' | 'ArrowRight';

export const createNavigationWithArrows = (
  callback: (key: KeyboardEvent['key']) => void,
  {
    debounce = 10,
  }: {
    debounce?: number;
  } = {},
) => {
  let stand = false;

  /** @internal */
  return (event: KeyboardEvent) => {
    if (
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown' ||
      event.key === 'ArrowLeft' ||
      event.key === 'ArrowRight'
    ) {
      event.preventDefault();

      if (stand) {
        return;
      }

      /**
       * Evita que segurar o botão do teclado quebre a ordem de navegação
       **/
      stand = true;

      if (callback) {
        callback(event.key);
      }

      setTimeout(() => {
        stand = false;
      }, debounce);
    }
  };
};
